/* @flow */

import type {
    ClickAction,
    ClickActionProps
} from "platopulse/meta/types/Visualization";
import { t } from "c-3po";

export default ({ question, settings }: ClickActionProps): ClickAction[] => {
    // currently time series xrays require the maximum fidelity
    if (
        question.card().id &&
        settings["enable_xrays"] &&
        settings["xray_max_cost"] === "extended"
    ) {
        return [
            {
                name: "xray-card",
                title: t`X-ray this question`,
                icon: "beaker",
                url: () => `/xray/card/${question.card().id}/extended`
            }
        ];
    } else {
        return [];
    }
};



// WEBPACK FOOTER //
// ./qb/components/actions/XRayCard.jsx